import React, { createContext, ReactNode, useContext } from 'react';
import { ContactCaptureBuilder } from './useContactCaptureBuilder';

const ContactCaptureBuilderContext = createContext<ContactCaptureBuilder | null>(null);

/**
 * The builder state is read by every tab and section. Passing it through context keeps the
 * component props honest: sections take only what they genuinely receive from a parent, instead
 * of re-declaring slices of the hook's return type that drift out of date.
 */
export const ContactCaptureBuilderProvider = ({
  builder,
  children,
}: {
  builder: ContactCaptureBuilder;
  children: ReactNode;
}) => (
  <ContactCaptureBuilderContext.Provider value={builder}>
    {children}
  </ContactCaptureBuilderContext.Provider>
);

export const useBuilder = (): ContactCaptureBuilder => {
  const builder = useContext(ContactCaptureBuilderContext);
  if (!builder) throw new Error('useBuilder must be used inside a ContactCaptureBuilderProvider.');
  return builder;
};
